import { createSelector } from "reselect";
import { AppState } from "../../../../store";
import { tripAttr } from "../../../config/constants";
import {
  tripTypeSelector,
  pageMakerSelector,
} from "./../../../common/redux/selector";
export const SrpSelector = (state: AppState) => state.srp;
export const SeoSelector = (state: AppState) => state.seoPage;
export const isSeoPage = (state: AppState) => state.seoPage?.isSeoPage || false;
export const resultsSelector = createSelector(
  isSeoPage ? SeoSelector : SrpSelector,
  (item) => item?.results || {}
);

export const loaderSelector = createSelector(
  SrpSelector,
  (item) => item?.loader || false
);

export const filterSelector = createSelector(
  SrpSelector,
  (item) => item?.results?.filter_data || {}
);

export const seoFilterSelector = createSelector(
  SeoSelector,
  (item) => item?.results?.filter_data || {}
);

export const commonSelector = createSelector(
  resultsSelector,
  (item) => item?.common_data || {}
);

export const topTextWebSelector = createSelector(
  commonSelector,
  (item) => item?.top_text_web || ''
);
export const startTimeSelector = createSelector(
  commonSelector,
  (item) => item?.start_time || ''
);

export const popupSelector = createSelector(
  commonSelector,
  (item) => item?.popup || null
);

export const endTimeSelector = createSelector(
  commonSelector,
  (item) => item?.end_time || ''
);

export const dynamicPersuasionSelector = createSelector(
  commonSelector,
  (item) => item?.dynamic_persuasions || {}
);

export const tripTypeResultsSelector = createSelector(
  commonSelector,
  (item) => {
    if (item.trip_type) {
      const data = {
        name: item?.trip_type_event === 'local-rental' ? 'LOCAL_RENTAL' : item.trip_type,
        rf: item?.trip_type_event === 'local-rental' ? tripAttr['LOCAL_RENTAL']?.rf : tripAttr[item.trip_type]?.rf
      }
      return data;
    }
    return {};
  }
);

export const vehicledataSelector = createSelector(
  SrpSelector,
  (item) => item?.results?.vehicle_data || []
);
export const srpCommonDataSelector = createSelector(
  SrpSelector,
  (item) => item?.results?.common_data || []
);

export const seoVehicleDataSelector = createSelector(
  SeoSelector,
  (item) => item?.results?.vehicle_data || []
);

export const selectedFilterSelector = createSelector(
  isSeoPage ? SeoSelector : SrpSelector,
  (item) => item?.filters || {}
);
export const dispatchSelector = createSelector(
  commonSelector,
  (item) => item?.dispatch_search_id || ""
);

export const isFilterAppliedSelector = createSelector(
  SrpSelector,
  (item) => item?.isFilterApplied || false
);
export const errorSelector = createSelector(
  resultsSelector,
  (item) => {
    const { response } = item;
    const { common_data = {} } = response || item;
    const { error = {} } = common_data;
    return error || {};
  }
);

export const benefitsDataSelector = createSelector(
  [pageMakerSelector, tripTypeSelector],
  (pageMaker, trip) => {
    const item = pageMaker?.['cabs_dweb_srp']?.benefits || {};
    let data = {};
    switch (trip.rf) {
      case "ow":
        data = item['ONE_WAY'];
        break;
      case "rt":
        data = item["ROUND_TRIP"];
        break;
      case "at":
        data = item["AIRPORT_PICK"];
        break;
      case "hr": 
        data = item["HOURLY_RENTAL"]
      default:
        break;
    }
    return data || {};
  }
);

export const safetyFeedHeaderSelector = createSelector(
  [pageMakerSelector],
  (pageMaker) => {
    const item = pageMaker?.['cabs_dweb_srp']?.safety_feeds || {};
    const { h = 'goSafe - Book Hygienic cabs', sl = [] } = item;
    return { h, sl };
  }
);

export const caSelector = createSelector(
  [pageMakerSelector],
  (pageMaker) => {
    const item = pageMaker?.['cabs_dweb_srp']?.c_a || {};
    return item || {};
  }
);

export const smartengageSeletor = createSelector(
  SrpSelector,
  (item) => {
    const { smartengage = {} } = item;
    const {cab_srp_carousel_1 = [] } = smartengage;
    return cab_srp_carousel_1 || [];
  }
);

// adding data for bluSmart modal from pageMaker api 
export const bluSmartTgpSeletor = createSelector(
  SrpSelector,
  (item) => {
    return item?.bluSmartTgp || {};
  }
);

export const hourlyPackageDetailsSelector = createSelector(
  SrpSelector,
  (item) => {
    return item?.hourlyRentalDetails || {};
  }
);

export const showCabTypeDetailModalSelector = createSelector(
  SrpSelector,
  (item) => {
    return item?.showCabTypeDetailsModal || false;
  }
);

export const listingAssistedFlowInfo = createSelector(
  SrpSelector,
  (item) => {
    return item.results?.common_data?.assisted_flow_info || null
  }
)

export const listingLeaveIntentInfo = createSelector(
  SrpSelector,
  (item) => {
    return item.results?.common_data?.leave_intent_config || null
  }
)




